/*
 * cart-addons.js
 * Add-ons del carrito ("Suma tu apoyo a la conservación").
 * Funciona en el DRAWER y en la página /cart con un solo manejador delegado.
 * - Drawer: agrega vía /cart/add.js y re-renderiza el drawer (Dawn renderContents).
 * - Página: re-renderiza main-cart-items / main-cart-footer / cart-icon-bubble.
 * El elemento <cart-addons> (solo en la página) se re-renderiza al evento
 * cart-update para respetar la regla de "solo si hay un producto principal".
 */
(function () {
  if (window.cartAddonsInitialized) return;
  window.cartAddonsInitialized = true;

  // --- Click en cualquier botón "Agregar" (delegado, sobrevive re-renders) ---
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-addon-add]');
    if (!button) return;
    event.preventDefault();
    addAddon(button);
  });

  function addAddon(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.dataset.variantId;
    const spinner = button.querySelector('.loading__spinner');
    const drawer = button.closest('cart-drawer');

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');

    const formData = { items: [{ id: Number(variantId), quantity: 1 }] };
    let pageSections = null;

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.sections = drawer.getSectionsToRender().map((s) => s.id);
      formData.sections_url = window.location.pathname;
    } else {
      pageSections = getPageSections();
      formData.sections = pageSections.map((s) => s.section);
      formData.sections_url = window.location.pathname;
    }

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          announce(button, response.description || response.message || '');
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-addons',
          productVariantId: variantId,
          cartData: response,
        });

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        } else {
          renderPageSections(response.sections, pageSections);
        }
      })
      .catch((error) => {
        console.error(error);
        announce(button, window.cartStrings ? window.cartStrings.error : 'Algo salió mal.');
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function getPageSections() {
    const sections = [];
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    if (items) sections.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer) sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return sections;
  }

  function renderPageSections(sections, list) {
    if (!sections) return;
    (list || getPageSections()).forEach((s) => {
      const html = sections[s.section];
      if (!html) return;
      const container = document.getElementById(s.id);
      if (!container) return;
      const target = container.querySelector(s.selector) || container;
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      target.innerHTML = parsed ? parsed.innerHTML : '';
    });
  }

  function announce(button, message) {
    const scope = button.closest('cart-drawer') || document;
    const status = scope.querySelector('.cart-addons__status');
    if (status) status.textContent = message || '';
  }

  // --- Página /cart: re-render del propio bloque para ocultarse/mostrarse ----
  if (!customElements.get('cart-addons')) {
    customElements.define(
      'cart-addons',
      class CartAddons extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-addons') return;
            return this.refresh();
          });
        }

        disconnectedCallback() {
          if (this.unsub) this.unsub();
        }

        refresh() {
          if (!this.sectionId) return;
          return fetch(`${routes.cart_url}?section_id=${this.sectionId}`)
            .then((r) => r.text())
            .then((text) => {
              const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('cart-addons');
              if (fresh) this.innerHTML = fresh.innerHTML;
            })
            .catch((e) => console.error(e));
        }
      }
    );
  }
})();
